import { useEffect, useState } from "react";

import { getUpDownCls } from "@/utils/method";

import { ClsUpDownEnum } from "store/app";

import usePrevious from "./usePrevious";

export interface TickerProps {
  s: string;
  c?: string;
  cr?: string;
  cv?: string;
  h?: string;
  l?: string;
  q?: string;
  v?: string;
}

const useUpDownClassTicker = (ticker: WithUndefined<TickerProps>, ret3Mode?: boolean): WithUndefined<ClsUpDownEnum> => {
  const [cls, setCls] = useState<WithUndefined<ClsUpDownEnum>>(getUpDownCls(ticker?.cv, ret3Mode));
  const prevTicker = usePrevious(ticker);

  useEffect(() => {
    if (!ticker) return setCls(undefined);
    if (!prevTicker || prevTicker.s !== ticker.s) return setCls(getUpDownCls(ticker.cv, ret3Mode));

    if (!ret3Mode && ticker.c === prevTicker.c) return;

    const currValue = +(ticker.c || 0) || 0;
    const prevValue = +(prevTicker.c || 0) || 0;
    setCls(getUpDownCls(currValue - prevValue, ret3Mode));
  }, [ticker, prevTicker, ret3Mode]);

  return cls;
};

export default useUpDownClassTicker;
